//
//
//
//
//
//
//
//
//
//
//

import footerMenu from '~~/data/footer.json'

export default {
  name: 'AppFooterNav',

  data() {
    return {
      footerMenu: footerMenu.filter(i => !i.hide)
    }
  }
}
